import { ImageBackground } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';

import { isUndefined as _isUndefined, isArray as _isArray } from 'lodash';
import memoize from 'memoize-one';

function getProperContainer(backgroundImage) {
  if (!_isUndefined(backgroundImage)) {
    return ImageBackground;
  }

  return LinearGradient;
}

function getProperProps(backgroundColors, backgroundImage) {
  if (!_isUndefined(backgroundImage)) {
    return { source: backgroundImage };
  } else if (!_isUndefined(backgroundColors) && _isArray(backgroundColors)) {
    return { colors: backgroundColors };
  } else if (!_isUndefined(backgroundColors)) {
    return { colors: [backgroundColors, backgroundColors] };
  }

  return {};
}

const getProperContainerMemoized = memoize(getProperContainer);
const getProperPropsMemoized = memoize(getProperProps);

export { getProperContainer, getProperContainerMemoized, getProperProps, getProperPropsMemoized };
